import React from "react";

const PlayDirectionIcon = ({ handleClick, extraClasses, size = "small" }) => {
  return (
    <button
      role="img"
      onClick={handleClick}
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon-next-video icon-svg fa-icon-svg--${size}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
          <g fill="none" fillRule="evenodd">
            <path d="M0 0h36v36H0z" />
            <path d="M9.82 9v18l12.73-9L9.82 9zm.8 1.68L20.98 18l-10.36 7.33V10.68z" fill="#FFF" />
            <path d="M27.4 9.5v17h-3.5v-17h3.5z" fillRule="nonzero" stroke="#FFF" />
            <g fill="#FFF">
              <path d="M9.82 9v18l12.73-9L9.82 9zm.8 1.68L20.98 18l-10.36 7.33V10.68z" />
            </g>
          </g>
        </svg>
      </span>
    </button>
  );
};

export default PlayDirectionIcon;
